/**
 * Identity provider singleton.
 *
 * Mirrors §6.2 of the Keycloak integration documentation. The exported
 * identifier (`ssoProvider`) and the file name (`sso.ts`) keep the rest of
 * the codebase free of identity-provider naming; only the npm package
 * import keeps the technology name and Vite mangles it in production.
 */
import Keycloak from 'keycloak-js';

const ssoProvider = new Keycloak({
  url: import.meta.env.VITE_AUTH_URL ?? 'https://auth.roommatik.com',
  realm: import.meta.env.VITE_AUTH_REALM ?? 'roommatik',
  // Respaldo a PRODUCCION (cliente `notify`): sin la variable, caer en `dev-notify`
  // rompia el SSO del despliegue real. En local manda .env.development.
  clientId: import.meta.env.VITE_AUTH_CLIENT_ID ?? 'notify',
});

export default ssoProvider;
